import { useTranslation } from 'react-i18next';
import { Button } from './Button';

export interface FormActionsProps {
    onCancel: () => void;
    /** Shows "Unsaved changes" on the left. */
    dirty?: boolean;
    submitting?: boolean;
    submitLabel?: string;
    cancelLabel?: string;
}

/** Sticky bar at the bottom of a form page; sticks to the bottom of the scroll area (the main column already pads for the bottom nav). It is in the page flow after the last section (never overlaps a field); same glass tokens in both themes. The submit button is type=submit. */
export const FormActions = ({ onCancel, dirty, submitting, submitLabel, cancelLabel }: FormActionsProps) => {
    const { t } = useTranslation();
    return (
        <div className="glass sticky bottom-0 z-20 -mx-gutter flex min-h-[4.5rem] items-center justify-between gap-3 border-b-0 border-t border-hairline px-gutter py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
            <p className="hidden text-small text-muted sm:block" role="status">
                {dirty ? t('ui.unsavedChanges') : ''}
            </p>
            <div className="flex w-full gap-3 sm:w-auto">
                <Button variant="quiet" onClick={onCancel} disabled={submitting} className="flex-1 sm:flex-none">
                    {cancelLabel ?? t('ui.cancel')}
                </Button>
                <Button type="submit" variant="primary" loading={submitting} className="flex-1 sm:flex-none">
                    {submitLabel ?? t('ui.save')}
                </Button>
            </div>
        </div>
    );
};
